import { render, staticRenderFns } from "./HxShoppingMall.vue?vue&type=template&id=5e2bad77&scoped=true"
import script from "./HxShoppingMall.vue?vue&type=script&lang=js"
export * from "./HxShoppingMall.vue?vue&type=script&lang=js"
import style0 from "./HxShoppingMall.vue?vue&type=style&index=0&id=5e2bad77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2bad77",
  null
  
)

export default component.exports